import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ApplicationState } from '@store/application-store';
import { combineLatest } from 'rxjs';
import { tap, take, filter, map } from 'rxjs';
import { IColumnDefinition } from '@common/models/column-definition';
import { Observable } from 'rxjs';
import * as arrearsTransactionTableColumnsActions from '../actions/arrears-transaction-table-columns.action';
import { ArrearsTransactionTableColumnsHttpService } from './arrears-transaction-table-columns-http.service';
import * as arrearsTransactionTableColumnSelectors from '../selectors/arrears-transaction-table-columns.selectors';

@Injectable()
export class ArrearsTransactionTableColumnsService {

  constructor(protected store: Store<ApplicationState>,
    private readonly arrearsTransactionTableColumnsHttpService: ArrearsTransactionTableColumnsHttpService) { }

  private loadAllColumns(): Observable<IColumnDefinition[]> {
    this.store.dispatch(new arrearsTransactionTableColumnsActions.LoadAll());
    return this.arrearsTransactionTableColumnsHttpService.getAllTableColumns()
      .pipe(
        tap((columns: IColumnDefinition[]) => {
          this.store.dispatch(new arrearsTransactionTableColumnsActions.LoadAllComplete(columns));
        }),
        take(1)
      );
  }

  getAllColumns(): Observable<IColumnDefinition[]> {
    const combined = combineLatest(this.store.select(arrearsTransactionTableColumnSelectors.getAllColumns()), this.loadAllColumns());

    const result = combined.pipe(
      map(([storeColumns, apiColumns]) => {
        return storeColumns;
      }),
      filter((columns: IColumnDefinition[]) => {
        return columns != undefined;
      })
    );

    return result;
  }
}
